import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
    const { isAuthenticated, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <div
                className="grid min-h-[calc(100vh-72px)] place-items-center bg-brand-charcoal text-brand-offwhite"
                data-testid="auth-loading"
            >
                <p className="font-mono-tag text-brand-gold">
                    [ AUTHENTICATING… ]
                </p>
            </div>
        );
    }

    if (!isAuthenticated) {
        return (
            <Navigate
                to="/portal/login"
                state={{ from: location.pathname + location.search }}
                replace
            />
        );
    }

    return children;
}
